module.exports = __webpack_public_path__ + "static/media/wizualizacja-53.1cde8bb5.png";